import * as yup from 'yup'

export const renewSubSchema = yup.object().shape({
    months: yup.string().required('ادخل مدة الاشتراك'),
    cost: yup.string().required('ادخل المبلغ المرا د دفعه'),
    status: yup.string().required('ادخل حالة الطلب'),
    payment_method_id: yup.string().required('ادخل طريقة الدفع المناسبة'),
    note: yup.string(),
})
